import type { FC } from 'react';

export const EuroIcon: FC<{ color?: string }> = ({ color = '#E6E6E9' }) => (
  <svg width="100%" height="100%" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M10.5 5a3.5 3.5 0 100 6M4 7h5M4 9h5" stroke={color} strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
  </svg>
);
